<template>
  <form
    id="create-profile"
    @submit="checkForm"
    action="#"
    method="post"
    novalidate="true"
  >
    <h3>{{ $t("onboard.profileCreateForm.welcome", { name: name }) }}</h3>
    <h1>{{ $t("onboard.profileCreateForm.header") }}</h1>
    <p v-html="$t('onboard.profileCreateForm.text')"></p>

    <label class="required" for="country">{{
      $t("onboard.profileCreateForm.country")
    }}</label>
    <select
      id="country"
      name="country"
      v-bind:class="{ error: errCountry }"
      v-model="selectedCountry"
    >
      <option
        v-for="(country, countryCode) in countries"
        v-bind:key="countryCode"
        v-bind:value="countryCode"
        >{{ country }}</option
      >
    </select>

    <label class="required" for="lang">{{
      $t("onboard.profileCreateForm.language")
    }}</label>
    <select
      id="lang"
      name="lang"
      v-bind:class="{ error: errLang }"
      v-model="languageCode"
    >
      <option
        v-for="(language, index) in languages"
        v-bind:key="index"
        v-bind:value="language.value"
        >{{ language.text }}</option
      >
    </select>

    <label for="company">{{
      $t("onboard.profileCreateForm.companyName")
    }}</label>
    <input
      id="company"
      v-bind:class="{ error: errCompany }"
      name="company"
      v-model="company"
    />

    <label for="industry">{{ $t("onboard.profileCreateForm.industry") }}</label>
    <select
      id="industry"
      name="industry"
      v-bind:class="{ error: errIndustry }"
      v-model="selectedIndustry"
    >
      <option default disabled :value="null">{{
        $t("onboard.profileCreateForm.placeholder")
      }}</option>
      <option
        v-for="(industry, index) in industries"
        v-bind:key="index"
        v-bind:value="industry.value"
        >{{ industry.text }}</option
      >
    </select>

    <label for="phone">{{ $t("onboard.profileCreateForm.phoneNumber") }}</label>
    <input
      id="phone"
      v-bind:class="{ error: errPhone }"
      name="phone"
      v-model="phone"
    />

    <input
      type="submit"
      class="submit"
      v-bind:value="$t('onboard.profileCreateForm.button.start')"
    />

    <SelectLang />
  </form>
</template>

<script>
import SelectLang from "@/components/onboard/SelectLanguage.vue";
import { userService } from "@/services/user.service";
import { planService } from "@/services/plan.service";
import { groupService } from "@/services/group.service";
import { countries } from "@/utils/countries";
import { language } from "@/utils/language";
import { validPhone } from "@/utils/validPhone";
import { validFileInclusion } from "@/utils/validFileInclusion";

export default {
  name: "SignUpFrom",
  components: { SelectLang },
  data() {
    let user = JSON.parse(localStorage.getItem("user"));
    return {
      invalidForm: true,
      errCountry: false,
      errCompany: false,
      errLang: false,
      errIndustry: false,
      errWebsite: false,
      errPhone: false,
      company: null,
      languageCode: "ja_JP",
      website: null,
      phone: null,

      name: user.userInfo.givenName,
      email: user.userInfo.emailAddress,
      userInfo: user.userInfo,

      selectedIndustry: null,
      industries: [
        {
          text: this.$t("onboard.profileCreateForm.select.item01"),
          value: "Consumer",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item02"),
          value: "Education",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item03"),
          value: "Energy & Utilities",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item04"),
          value: "Finance",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item05"),
          value: "Government",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item06"),
          value: "Healthcare",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item07"),
          value: "Manufacturing",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item08"),
          value: "Materials",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item09"),
          value: "Non-profit",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item10"),
          value: "Professional Services",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item11"),
          value: "Research",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item12"),
          value: "Technology",
        },
        {
          text: this.$t("onboard.profileCreateForm.select.item13"),
          value: "Transportation",
        },
      ],

      selectedCountry: "JP",
      countries: countries(),
      languages: language(),
    };
  },
  methods: {
    checkForm: function(event) {
      this.invalidForm = false;
      this.errCountry = false;
      this.errCompany = false;
      this.errLang = false;
      this.errIndustry = false;
      this.errWebsite = false;
      this.errPhone = false;

      // If-stravaganza
      if (!this.selectedCountry) {
        this.invalidForm = true;
        this.errCountry = true;
      }
      if (this.company && validFileInclusion(this.company)) {
        this.invalidForm = true;
        this.errCompany = true;
      }
      if (!this.languageCode) {
        this.invalidForm = true;
        this.errLang = true;
      }
      if (this.phone && !validPhone(this.phone)) {
        this.invalidForm = true;
        this.errPhone = true;
      }

      // Form passed validation!
      if (!this.invalidForm) {
        this.createProfile();
      }
      event.preventDefault();
    },

    createProfile: function() {
      let me = JSON.parse(localStorage.getItem("user"));

      let userUpdate = {
        countryOrRegion: this.selectedCountry,
        languageCode: this.languageCode,
        companyName: this.company,
        industry: this.selectedIndustry,
        businessWebsiteDomain: this.website,
        phoneNumber: this.phone,
      };

      userService.update(userUpdate).then((userInfo) => {
        // Update our local store of the profile.
        me.userInfo = userInfo;
        localStorage.setItem("user", JSON.stringify(me));
        this.$i18n.locale = this.languageCode;
        localStorage.setItem("lang", this.languageCode);

        //this.createPlan()
        if (this.$route.query.dest) {
          this.$router.push(this.$route.query.dest);
        } else {
          this.$router.push("plans");
        }
      });
    },

    createPlan: function() {
      planService.create(this.email, this.company).then((plan) => {
        this.createGroup(plan.id);
      });
    },

    createGroup: function(planId) {
      let groupInfo = {
        description: this.company,
        enabled: true,
        name: this.userInfo.givenName + " " + this.userInfo.familyName,
      };

      planService.createGroup(planId, groupInfo).then((group) => {
        this.createProject(group.id);
      });
    },

    createProject: function(groupId) {
      let projectInfo = {
        description: this.company,
        enabled: true,
        name: this.userInfo.givenName + " " + this.userInfo.familyName,
      };

      groupService.createProject(groupId, projectInfo).then((project) => {
        this.$router.push("plans");
      });
    },
  },
};
</script>
